import React from 'react';
import { Card } from 'reactstrap';
import { get_experience, get_last_used } from '../../../../../../components/company-dash/utils';

const JobSeekerSkills = ({ skill }) => {
  return (
    <Card className="profile-completion-skill-card card-animate border border-primary mb-2">
      <div
        className="d-flex justify-content-between flex-column text-start "
        style={{ wordBreak: "break-word" }}
      >
        <h5 className="text-primary fw-bold d-flex justify-content-between">
          <span style={{ fontSize: "inherit", color: "inherit", fontWeight: "inherit" }}>
            {skill?.skill}
          </span>
        </h5>
        {skill?.experience && <p className="mb-0 text-dark">
          <span className="fw-semibold" style={{ fontSize: "13px" }}>Experience:</span> {get_experience(skill?.experience)}
        </p>}
        {skill?.last_used && <p className="mb-0 text-dark">
          <span className="fw-semibold" style={{ fontSize: "13px" }}>Last Used:</span> {get_last_used(skill?.last_used)}
        </p>}
      </div>
    </Card>
  )
}

export default JobSeekerSkills